import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Internal from 'common/modules/internal'
import keyEventListener from 'common/keyEventListener'

class App extends React.Component {
    componentDidMount() {
        const { attachEventListener, shouldAttachListener } = this.props
        if (shouldAttachListener) {
            attachEventListener(window)
        }
    }

    render() {
        const { children } = this.props

        return (
            <>
                {children}
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    attachEventListener: (context) => {
        keyEventListener({
            context,
            keys: [
                {
                    key: 'Escape',
                    eventName: 'keydown',
                    action: () => {
                        dispatch(Internal.creators.closePico())
                    },
                },
            ],
        })
    },
})

App.defaultProps = {
    attachEventListener: () => {},
    shouldAttachListener: false,
}

App.propTypes = {
    children: PropTypes.node.isRequired,
    attachEventListener: PropTypes.func,
    shouldAttachListener: PropTypes.bool,
}

export default connect(null, mapDispatchToProps)(App)
